import script from "./SubscriptionContent.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionContent.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionContent.vue?vue&type=style&index=0&id=0dcd90bc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dcd90bc"]])

export default __exports__